import React from 'react';
import {IonIcon, IonSkeletonText} from '@ionic/react';
import {arrowUpOutline, arrowDownOutline, removeOutline, speedometerOutline} from 'ionicons/icons';
import {DashboardCard} from '../DashboardCard';
import {usePressure} from '@/hooks/usePressure';
import {useRelativeTime} from "@/hooks/useRelativeTime";

type PressureTrend = 'up' | 'down' | 'stable';


export const AtmosphericPressureWidget: React.FC = () => {
    const {data: pressure, isLoading, error} = usePressure();
    const relativeTime = useRelativeTime(pressure?.timestamp);

    const getTrendIcon = (trend: PressureTrend) => {
        switch (trend) {
            case 'up':
                return arrowUpOutline;
            case 'down':
                return arrowDownOutline;
            case 'stable':
                return removeOutline;
        }
    };

    const getTrendColor = (trend: PressureTrend) => {
        switch (trend) {
            case 'up':
                return 'text-green-600';
            case 'down':
                return 'text-red-600';
            case 'stable':
                return 'text-gray-600';
        }
    };

    if (error) {
        return (
            <DashboardCard title="Pression atmosphérique">
                <div className="text-center py-4 text-red-600 text-sm">
                    Erreur de lecture
                </div>
            </DashboardCard>
        );
    }

    const handleViewMore = () => {
        console.log('Navigation vers /sensors/pressure - À implémenter');
    };

    return (
        <DashboardCard title="Pression atmosphérique" subtitle={relativeTime} onAction={handleViewMore}
                       icon={speedometerOutline}>
            {isLoading ? (
                <div className="flex flex-col items-center py-4">
                    <IonSkeletonText animated style={{width: '60%', height: '48px'}}/>
                    <IonSkeletonText animated style={{width: '40%', height: '20px', marginTop: '8px'}}/>
                </div>
            ) : (
                <div className="flex flex-col items-center py-2">
                    <div className="flex items-baseline gap-2">
            <span className="text-4xl font-bold text-gray-900 dark:text-gray-100">
              {parseFloat(pressure?.value || '0').toFixed(1)}
            </span>
                        <IonIcon
                            icon={getTrendIcon(pressure?.trend || 'stable')}
                            className={`text-2xl ${getTrendColor(pressure?.trend || 'stable')}`}
                        />
                    </div>

                    <span className="text-sm text-gray-500 dark:text-gray-400 mt-1">
            {pressure?.unit || 'hPa'}
          </span>
                </div>
            )}
        </DashboardCard>
    );
};